import { values } from './_helpers'

const _enum = {
  other: 1,
  lowe24: 24,
  lowe240: 240,
  lowe1000: 1000
}

const loweIndex = { ..._enum, name: 'loweIndex', values: values(_enum) }

export {
  loweIndex
}
